import {call, put} from 'redux-saga/effects';
import CampaignsActions from '../redux/CampaignsRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getCampaigns(api, action) {
  const response = yield call(api.getCampaigns, {...action.props});

  if (response.ok) {
    yield put(CampaignsActions.campaignsSuccess({...response.data, ...action.props}));
  } else {
    yield put(CampaignsActions.campaignsFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
